<template>
  <div class="section">
    <div class="section-header">
      <div class="section-info">
        <span class="section-title">依赖项管理</span>
      </div>
      <div class="section-controls">
        <button class="header-action" title="在线依赖库" @click="$emit('add-online')">
          <ElIcon><Link /></ElIcon>
        </button>
        <button class="header-action" title="上传自定义库" @click="$emit('upload-custom')">
          <ElIcon><Folder /></ElIcon>
        </button>
      </div>
    </div>
    <div class="section-content" v-show="expanded">
      <div class="dependency-types">
        <div class="type-tabs">
          <button class="type-tab" :class="{ 'active': activeType === 'umd' }" @click="$emit('change-type', 'umd')">UMD</button>
          <button class="type-tab" :class="{ 'active': activeType === 'cjs' }" @click="$emit('change-type', 'cjs')">CJS</button>
          <button class="type-tab" :class="{ 'active': activeType === 'es' }" @click="$emit('change-type', 'es')">ES</button>
        </div>
        <div class="dependency-list">
          <div class="dependency-item" v-for="dep in dependencies" :key="dep.id">
            <div class="dependency-info">
              <div class="dependency-name">{{ dep.name }}</div>
              <div class="dependency-version">v{{ dep.version }}</div>
            </div>
            <div class="dependency-actions">
              <span class="type-badge">{{ (dep.type || '').toUpperCase() }}</span>
              <button class="icon-btn " @click="$emit('load', dep)" title="加载">
                <ElIcon><Download /></ElIcon>
              </button>
              <button class="icon-btn danger" @click="$emit('remove', dep)" title="移除">
                <ElIcon><Close /></ElIcon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElIcon, Link, Folder, Download, Close } from '@/plugins/elementPlus'

const props = defineProps<{
  expanded: boolean
  activeType: 'umd' | 'cjs' | 'es' | string
  dependencies: any[]
}>()

const emit = defineEmits<{
  (e: 'toggle'): void
  (e: 'change-type', type: 'umd' | 'cjs' | 'es' | string): void
  (e: 'add-online'): void
  (e: 'upload-custom'): void
  (e: 'load', dep: any): void
  (e: 'remove', dep: any): void
}>()
</script>

<style scoped lang="scss">
.section { margin: 0; border-radius: 6px; background: #1f1f1f; overflow: hidden; display: flex; flex-direction: column; }
.section-header { display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; border-bottom: 1px solid #333333; cursor: pointer; user-select: none; }
.section-info { display: flex; align-items: center; gap: 8px; flex: 1; }
.section-title { color: #cccccc; font-size: 12px; font-weight: 500; }
.section-controls { display: flex; align-items: center; gap: 6px; height: 30px; }
.header-action { background: #333333; border: none; width: 20px; height: 20px; color: #bbb; border-radius: 4px; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
.header-action:disabled { opacity: 0.5; cursor: not-allowed; }
.header-action:hover { background: #333; color: #fff; border-color: #666; }
.section-content { padding: 6px; flex: 1; overflow-y: auto; background: #1e1e1e; }
.dependency-types { margin-bottom: 6px; }
.type-tabs { display: flex; gap: 6px; }
.type-tab { background: #2a2a2a; color: #ccc; border: 1px solid #444; border-radius: 4px; padding: 4px 8px; cursor: pointer; font-size: 11px; }
.type-tab.active { background: rgba(0,137,255,0.06); border-color: #0089FF;}
.dependency-list { display: flex; flex-direction: column; gap: 4px; }
.dependency-item { display: flex; align-items: center; justify-content: space-between; padding: 6px 8px; background: #2a2a2a; border: 1px solid transparent; border-radius: 4px; cursor: pointer; transition: all 0.2s; }
.dependency-item:hover { background: #333; border-color: #444; }
.dependency-info { flex: 1; min-width: 0; }
.dependency-name { color: #cccccc; font-size: 11px; font-weight: 500; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.dependency-version { color: #888; font-size: 10px; margin-top: 2px; }
.dependency-actions { display: flex; align-items: center; gap: 6px; }
.type-badge { background: #2a2a2a; border: 1px solid #444; color: #bbb; font-size: 10px; border-radius: 10px; padding: 2px 6px; }
.icon-btn { background: none; border: 1px solid #444; color: #bbb; padding: 4px 6px; border-radius: 4px; cursor: pointer; transition: all .2s; }
.icon-btn:hover { background: #333; color: #fff; border-color: #666; }
.icon-btn.danger:hover { background: #3a2424; border-color: #8b0000; color: #ffdddd; }
</style>
